export const COMPANY_LEVELS = [
  'none',
  'iron',
  'bronze',
  'silver',
  'gold',
  'platinum',
] as const;

export type CompanyLevelType = (typeof COMPANY_LEVELS)[number];

export type RankedCompanyLevel = Exclude<CompanyLevelType, 'none'>;

/** Минимальный балл уровня (по таблице бэка). */
export const COMPANY_LEVEL_MIN_SCORE: Record<RankedCompanyLevel, number> = {
  iron: 0.0,
  bronze: 1.1,
  silver: 2.1,
  gold: 3.1,
  platinum: 4.1,
};

export const COMPANY_LEVEL_LABELS: Record<CompanyLevelType, string> = {
  none: 'Нет уровня',
  iron: 'Железный уровень',
  bronze: 'Бронзовый уровень',
  silver: 'Серебряный уровень',
  gold: 'Золотой уровень',
  platinum: 'Платиновый уровень',
};

const isCompanyLevel = (value: string): value is CompanyLevelType =>
  (COMPANY_LEVELS as readonly string[]).includes(value);

export const normalizeCompanyLevel = (
  level?: string | null
): CompanyLevelType => {
  if (!level?.trim()) {
    return 'none';
  }

  const normalized = level.trim().toLowerCase();

  return isCompanyLevel(normalized) ? normalized : 'none';
};

export const formatCompanyRating = (
  rating?: number | string | null
): string => {
  if (rating === null || rating === undefined || rating === '') {
    return '0.0';
  }

  const numericRating = typeof rating === 'number' ? rating : Number(rating);

  if (Number.isNaN(numericRating)) {
    return '0.0';
  }

  return numericRating.toFixed(1);
};

export const parseCompanyRating = (rating?: number | string | null): number => {
  return Number(formatCompanyRating(rating));
};
